import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import styled from '../../styles/styled';
import { SelectableIconButtonWithLabel } from '../buttons/selectable_icon_button_with_label';
import { BOTTOM_ROW_ELEMENT_HEIGHT_REM } from '../../util/constants';
import { getBorderRadiusProps } from '../../util/buttons';
export const LaserAndMarker = ({ roundLeftEdgeYn, roundRightEdgeYn, disabled, onSelectLaser, onSelectMarker, selectedTool, }) => {
    return (_jsxs(LaserAndMarkerWrapper, { children: [_jsx(SelectableIconButtonWithLabel, { onClick: onSelectLaser, iconName: "LaserPointerIcon", label: "Pointer", color: "blue50", selectedColor: "white", hoverColor: "blue50", hoverBackgroundColor: "grey10", isSelectedYn: selectedTool === 'LASER', disabled: disabled, "data-testid": "laser-pointer-button", roundLeftEdgeYn: roundLeftEdgeYn, roundRightEdgeYn: false }), _jsx(SelectableIconButtonWithLabel, { onClick: onSelectMarker, iconName: "MarkerIcon", label: "Marker", color: "blue50", selectedColor: "white", hoverColor: "blue50", hoverBackgroundColor: "grey10", isSelectedYn: selectedTool === 'MARKER', disabled: disabled, "data-testid": "marker-button", roundLeftEdgeYn: false, roundRightEdgeYn: roundRightEdgeYn }), _jsx(AnimationComponent, { selectedTool: selectedTool, disabled: disabled, roundLeftEdgeYn: roundLeftEdgeYn, roundRightEdgeYn: roundRightEdgeYn })] }));
};
const LaserAndMarkerWrapper = styled.span(() => {
    return {
        display: 'inline-flex',
        position: 'relative',
        '>button': {
            zIndex: 2,
        },
    };
});
// This is a "workaround" to achieve the desired animation when switching the selected tool.  This span
//     has a blue50 background color and is placed under the selected button to show the active button.
//     This method was used instead of background-color on the buttons so that the animation can be
//     on the transition of the X coordinate.
const AnimationComponent = styled.span(({ selectedTool, roundLeftEdgeYn, roundRightEdgeYn, disabled, theme }) => {
    // this component is not flexible--it depends on both the laser and pointer buttons having a width of ~4.375rem
    const width = '4.375rem';
    const translateX = selectedTool === 'LASER' ? 0 : width;
    const roundLeftSide = roundLeftEdgeYn && selectedTool === 'LASER';
    const roundRightSide = roundRightEdgeYn && selectedTool === 'MARKER';
    const borderRadius = getBorderRadiusProps(roundLeftSide, roundRightSide);
    return {
        position: 'absolute',
        transform: `translateX(${translateX})`,
        // also transition on border-radius to smooth out the appearance when one of the buttons has a rounded edge
        transition: 'transform 200ms cubic-bezier(0.25,-0.20, 0.40, 1.25)  border-radius 0',
        backgroundColor: disabled ? theme.colors.transparent : theme.colors.blue50,
        width,
        zIndex: 1,
        height: `${BOTTOM_ROW_ELEMENT_HEIGHT_REM}rem`,
        ...borderRadius,
    };
});
//# sourceMappingURL=laser_and_marker.js.map